import { MenuItem, Select, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useChoiceState } from '@context/ChoiceContext'
import useStyles, { selectMenu } from './styles'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { useSelectPatientType } from '@hooks/useSelectPatientType'

export const PatientTypeSelect = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { patientType = '' } = useChoiceState()
  const selectPatientType = useSelectPatientType()
  const theme = useTheme()

  const patientTypesValues = [
    {
      label: t('returning_patient_type'),
      value: PatientTypeOptions.OLD,
    },
    {
      label: t('new_patient_type'),
      value: PatientTypeOptions.NEW,
    },
  ]

  const handlePatientTypeChange = (newValue: PatientTypeOptions) => selectPatientType(newValue)

  return (
    <Select
      className={classes.select}
      MenuProps={{
        style: selectMenu(theme),
      }}
      value={patientType}
      onChange={(e) => handlePatientTypeChange(e.target.value as PatientTypeOptions)}
      displayEmpty
    >
      {!patientType && (
        <MenuItem value="" sx={selectMenu} selected>
          {t('please_select')}
        </MenuItem>
      )}
      {patientTypesValues.map(({ label, value }) => (
        <MenuItem key={value} value={value} sx={selectMenu}>
          {label}
        </MenuItem>
      ))}
    </Select>
  )
}
